import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import i18n from 'i18n-js';
import styles from '../../style/scanpack';
import CommonStyles from '../../style/commonStyles';
import globalStyles from '../../style/global';
import DefaultInput from '../../commons/Inputs/defaultInput';

// The L2/L3 ask/answer round trip — visually modeled on ClickScanConfirmationPopUp
// (../scanpack/click_scan_confirmation_pop_up.js) so packers see one consistent prompt
// shape across the app. L2 asks for the packer's own confirmation code; L3 asks for the
// lot number itself. `error` is a string (not a boolean) once the packer has answered
// wrong, mirroring the backend's ask_payload — its presence, not its content, drives the
// red banner.
// `isSubmitting` mirrors the scan-pack `loading` flag, which the gated-scan thunks set for the
// duration of the server round trip. Both the Enter key and the button call the same handler, so
// without this a double-tap (or Enter-then-tap) fires two gated round trips for one answer — the
// server would process the second against state the first had already changed. The flag is set
// and cleared by the thunk itself, so it can never stick if a request fails.
const WmsLotVerificationPrompt = ({
  message,
  input,
  onChangeInput,
  onSubmit,
  onCancel,
  error,
  isSubmitting = false,
  testID = 'wmsLotVerificationPrompt'
}) => {
  const handleSubmit = () => {
    if (isSubmitting) return;
    onSubmit();
  };

  return (
    <View style={styles.typeScanContainer} dataSet={{ componentName: 'wmsLotVerification' }} testID={testID}>
      <View style={{ width: '60%' }}>
        {error ? (
          <LinearGradient
            testID="wmsLotVerificationErrorBanner"
            locations={[0, 1]}
            colors={['rgb(207,68,55)', 'rgb(122,40,40)']}
            style={CommonStyles.gradientContainer}
          >
            <View style={globalStyles.flexDirectionRow}>
              <Text style={[styles.scanCountText, { color: '#ffff', marginLeft: 5 }]}>
                {typeof error === 'string' ? error : i18n.t('wmsLotVerification.confirmationCodeError')}
              </Text>
            </View>
          </LinearGradient>
        ) : null}

        <LinearGradient
          testID="wmsLotVerificationContainer"
          locations={[0, 1]}
          start={{ x: 0, y: 1 }}
          end={{ x: 0, y: 0 }}
          colors={['#d47d02', '#ffb636']}
          style={CommonStyles.gradientContainerOne}
        >
          <View style={globalStyles.flexDirectionRow}>
            <Text style={[styles.scanCountText, { marginLeft: '5%', marginTop: '2%' }]}>
              {message}
            </Text>
          </View>
          <View style={{ alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            <View style={{ alignItems: 'center', width: '80%' }}>
              <DefaultInput
                testID="wmsLotVerificationInput"
                value={input}
                onChangeText={onChangeInput}
                autoFocus={true}
                onSubmitEditing={handleSubmit}
                style={styles.scanCountTextInput}
              />
            </View>
            <View style={{ flexDirection: 'row' }}>
              <TouchableOpacity
                testID="wmsLotVerificationCancel"
                style={[styles.scanCountButton, { marginLeft: '-50%' }]}
                onPress={onCancel}
              >
                <Text>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity
                testID="wmsLotVerificationSubmit"
                style={[styles.scanCountButton, { marginLeft: '100%' }]}
                onPress={handleSubmit}
                disabled={isSubmitting}
              >
                <Text>Enter</Text>
              </TouchableOpacity>
            </View>
          </View>
        </LinearGradient>
      </View>
    </View>
  );
};

export default WmsLotVerificationPrompt;
